export enum CardType {
  INFORME_RENDIMENTOS = 'INFORME_RENDIMENTOS',
  INFORME_CONTRIBUICAO = 'INFORME_CONTRIBUICAO',
  INFORME_FORD = 'INFORME_FORD',
  INFORME_FAMILINVEST = 'INFORME_FAMILINVEST',
  INFORME_ROCHEPREV = 'INFORME_ROCHEPREV',
  EXTRATO_SAUDE = 'EXTRATO_SAUDE'
}
